/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/camelcase */
import * as React from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { Waypoint } from 'react-waypoint';
import { withStyles, Theme } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import TextField from '@material-ui/core/TextField';
import { useDebounce } from 'react-use';
import { Grid } from '@material-ui/core';
import { colors } from '../../../theme/theme';
import HtmlContent from '../html-content';
import Spinner from '../spinner';
import TypeaheadDropdown from './typeahead-dropdown';
import CustomLink from '../custom-link';
import APIManager from '../../../utilities/api-manager';
import History from '../../../utilities/history';
import { cn, getConfig, getText, get, authdata, createSearchStrategyFactory, SearchType, validInternalUser } from '../../../helpers';
import { mapSearchResultToDataProfileCard, mapSearchResultToSolution, mapSearchResultToBluePrint } from '../../../utilities/data-mappers';
import { ModalContext } from '../modal/modal';
import { ReactComponent as ClearIcon } from '../../../assets/svg/icons/close.svg';
import { ReactComponent as TabIcon } from '../../../assets/svg/icons/tab.svg';
import GenAIResponse from '../../gen-ai-search-result';
import SPGVariables from '../../../utilities/spg-variables';
import './typeahead.style.scss';
import SearchEmptyResults from '../../search-empty-results/search-empty-results';
import { ReactComponent as SearchAllFilterIcon } from '../../../assets/svg/icons/search-all-filter.svg';
import { ReactComponent as DatasetsFilterIcon } from '../../../assets/svg/icons/datasets-filter.svg';
import { ReactComponent as SolutionsFilterIcon } from '../../../assets/svg/icons/solutions-filter.svg';
import { ReactComponent as BlueprintsFilterIcon } from '../../../assets/svg/icons/blueprint-filter.svg';
import { ReactComponent as KenshoIcon } from '../../../assets/svg/icons/kensho.svg';
import Filter from '../filter';

const langCode = getText('langCode');
const searchAllFilter = getText('searchFilters.searchAllText');
const datasetsFilter = getText('searchFilters.DatasetsText');
const solutionsFilter = getText('searchFilters.SolutionsText');
const blueprintsFilter = getText('searchFilters.BlueprintsText');
// const genAIPlaceholder = getText('pages.home.genAIprompt');
// const genAILogoutPlaceholder = getText('pages.home.genAILogoutprompt');
const kenshoIconTooltip = getText('pages.llm.tooltip');
const searchErrorMessage = getText('pages.llm.errorMessage');
const maxSearchTextError = getText('pages.llm.maxSearchTextError');
const Window = window as AnonymousObject;
Window.dataLayer = Window.dataLayer || [];
const spgVariables = SPGVariables();
const env = spgVariables.ENV;

const UnstyledTextInput = withStyles({
    root: {
        'flex-direction': 'row',
        '& .MuiInput-underline:before': {
            content: 'none'
        },
        '& .MuiInput-underline:after': {
            content: 'none'
        },
        '& .MuiInput-input': {
            height: '100%',
            lineHeight: 1.1
        }
    }
})(TextField);

const HtmlTooltip = withStyles((theme: Theme) => ({
    tooltip: {
        backgroundColor: colors.white,
        color: colors.black,
        maxWidth: theme.typography.pxToRem(400),
        fontSize: theme.typography.pxToRem(14),
        border: `${theme.typography.pxToRem(1)} solid ${colors.grey80}`,
        [theme.breakpoints.down('sm')]: {
            maxWidth: theme.typography.pxToRem(350),
            fontSize: theme.typography.pxToRem(12),
            width: 350,
            paddingLeft: 10,
        },
    }
}))(Tooltip);

const throttleDuration = getConfig('components.typeaheadThrottleDuration');
const seeAllResults = getText('generic.seeAllResults');

// function searchBarTabIcon() {
//     return (
//         <div className="typeahead__tabcomp" role="alert">
//             <div style={{ border: 'solid 1px lightgray', borderRadius: '5px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '5px 8px', height: '35px' }}>
//                 <button type="button" className="button button--icon-only typeahead__tabicon" aria-label="tab-icon" tabIndex={-1} aria-hidden>
//                     <TabIcon />
//                 </button>
//                 <span className="typeahead__tabtext">Tab</span>
//             </div>
//             <span className="typeahead__tabmoretext">to change type</span>
//         </div>
//     );
// }

function Typeahead(props: TypeaheadProps) {
    const {
        searchText,
        iconPrepend,
        iconAppend,
        name,
        className,
        placeholder,
        onFocusEvent,
        onChangeEvent,
        isMobileDropdown,
        autoClose = false,
        onComplete,
        isModal,
        emptySearchSection = { title: '', content: '' },
        showSearchFilters,
        isGlobalClick,
        awayClose,
        onSearchTypeChanged,
        onDisableEnableSearchBtn
    } = props;

    const user = useSelector((state: RootStoreState) => get(state, 'user', ''));
    const enabledBlueprintFlag = useSelector((state: RootStoreState) => get(state, 'shared.flags.enabledBlueprintFlag', false));
    const userEmail = user && user.userInfo && user.userInfo.Email ? user.userInfo.Email : '';
    const [deliveryPlatforms, setDeliveryPlatforms] = React.useState([]);
    const deliveryPlatformsFromState = useSelector((state: RootStoreState) => get(state, 'filters.deliveryPlatform', []));
    const [response, setResponse] = React.useState<(DataProfileCard | APISolution | APIBlueprint)[]>([]);
    const [searchValue, setSearchValue] = React.useState<string>('');
    const [loading, setLoading] = React.useState<boolean>(false);
    const [showClearBtn, setShowClearBtn] = React.useState<boolean>(false);
    const [showTabBtn, setShowTabBtn] = React.useState<boolean>(false);
    const [searchFilterState, setSearchFilterState] = React.useState<string>('Search all');
    const [showDSBtn, setShowDSBtn] = React.useState<boolean>(true);
    const [showSolBtn, setShowSolBtn] = React.useState<boolean>(true);
    const [showBPBtn, setShowBPBtn] = React.useState<boolean>(true);
    const [isIpadIphone, setIsIpadIphone] = React.useState<boolean>(false);
    const [landscapeMode, setLandscapeMode] = React.useState<boolean>(false);
    const [isLLMSearch, setIsLLMSearch] = React.useState<boolean>(false);
    const [isMobile, setIsMobile] = React.useState<boolean>(false);
    const [submitGenAISearch, setSubmitGenAISearch] = React.useState<boolean>(false);
    const [genAIResponse, setGenAIResponse] = React.useState<any>();
    const [currPlaceholderIndex, setCurrPlaceholderIndex] = React.useState<number>(0);
    const [hasGenAISearchError, setHasGenAISearchError] = React.useState<boolean>(false);
    const [clearFeedbackFlag, setClearFeedbackFlag] = React.useState<boolean>(false);
    const [feedback, setFeedback] = React.useState<string>('');
    const textFieldRef: React.RefObject<HTMLInputElement> = React.useRef(null);
    const textFieldAndDropdownRef: React.RefObject<HTMLDivElement> = React.useRef(null);
    const clearIconRef: React.RefObject<HTMLButtonElement> = React.useRef(null);
    const [maxCharErrMsg, setMaxCharErrMsg] = React.useState<string>('');
    const [awayClosePrevState, setAwayClosePrevState] = React.useState<boolean | undefined>();
    const [maxChars, setMaxChars] = React.useState<number>(20);
    const [isTextArea, setIsTextArea] = React.useState(false);
    const [showDeliveryPlatformSelector, setShowDeliveryPlatformSelector] = React.useState<boolean>(false);
    const isLoggedIn = user && user.isLoggedIn ? user.isLoggedIn : false;
    const isValidUser = user ? validInternalUser(user) : false;
    const tileNameList = useSelector((state: RootStoreState) => get(state, 'shared.tileNamesGt25Chars', {}));
    const tileNamesGt25CharsList = tileNameList && tileNameList.data && tileNameList.data.TileNames ? tileNameList.data.TileNames : [];
    const [currLogoutPlaceholderIndex, setCurrLogoutPlaceholderIndex] = React.useState<number>(0);
    const [genAIPlaceholder, setGenAIPlaceholder] = React.useState<string[]>([]);
    const [genAILogoutPlaceholder, setGenAILogoutPlaceholder] = React.useState<string[]>([]);

    const { getSearchStrategy } = createSearchStrategyFactory();

    const [open, setOpen] = React.useState(false);
    const [isTouchDevice, setIsTouchDevice] = React.useState(false);
    const checkIfMobile = () => {
        if (navigator.platform === 'iPhone'
            || navigator.userAgent.includes('Android')
            || navigator.userAgent.includes('iPhone')
            || (window.innerWidth <= 800 && window.innerHeight <= 600)) {
            setIsMobile(true);
        } else setIsMobile(false);
    };
    const useDeviceDetect = () => {
        if (!window.matchMedia) return;
        setIsTouchDevice(window.matchMedia('(pointer:coarse)').matches);
    };

    const handleTooltipOpen = () => {
        setOpen(true);
    };

    const handleTooltipClose = () => {
        setOpen(false);
    };

    const showToolTipIcon = () => {
        return (
            <HtmlTooltip
                placement="top"
                arrow
                interactive
                enterTouchDelay={0}
                tabIndex={0}
                aria-label="info tooltip"
                role="button"
                title={
                    <>
                        <HtmlContent className="tooltip-content" html={kenshoIconTooltip} />
                    </>
                }
            >
                <KenshoIcon id="kenshoIcon" className="typeahead__kenshoicon" />
            </HtmlTooltip>
        );
    };

    const showMobileToolTipIcon = () => {
        return (
            <HtmlTooltip
                placement="top"
                arrow
                interactive
                leaveTouchDelay={4000}
                tabIndex={0}
                aria-label="info tooltip"
                role="button"
                open={open}
                onFocus={handleTooltipOpen}
                onClose={handleTooltipClose}
                title={
                    <>
                        <HtmlContent className="tooltip-content" html={kenshoIconTooltip} />
                    </>
                }
            >
                <KenshoIcon id="kenshoIcon" onClick={handleTooltipOpen} className="typeahead__kenshoicon" />
            </HtmlTooltip>
        );
    };

    const decide = () => {
        const searchStrategy = getSearchStrategy(searchValue.trim(), tileNamesGt25CharsList);
        if (searchStrategy) return searchStrategy.apply();
        return SearchType.openSearch;
    };

    const getSearchType = () => {
        setIsLLMSearch(false);
        if (searchValue && searchValue.trim() && searchValue.trim().length > 0) {
            const type = decide();
            if (type === SearchType.llmSearch) setIsLLMSearch(true);
            return type;
        }
        return SearchType.openSearch;
    };

    React.useEffect(() => {
        if (!isLLMSearch) {
            setGenAIResponse(null);
            setSubmitGenAISearch(false);
            setHasGenAISearchError(false);
            if (onSearchTypeChanged) onSearchTypeChanged(false);
        } else {
            setSearchFilterState('Search all');
            setResponse([]);
            setShowDSBtn(true);
            setShowSolBtn(true);
            setShowBPBtn(true);
        }
    }, [isLLMSearch]);

    React.useEffect(() => {
        if (!deliveryPlatforms.length && deliveryPlatformsFromState && deliveryPlatformsFromState.length) setDeliveryPlatforms(deliveryPlatformsFromState);
    }, [deliveryPlatformsFromState]);

    React.useEffect(() => {
        if (!awayClose && awayClosePrevState) APIManager.cancelApiRequest();
        setAwayClosePrevState(awayClose);
    }, [awayClose]);

    const getLandscapeMode = () => {
        if (window.innerWidth > window.innerHeight && window.innerWidth <= 1080) setLandscapeMode(true);
        else setLandscapeMode(false);
    };

    const handleResize = () => {
        getLandscapeMode();
        checkIfMobile();
        useDeviceDetect();
    };

    React.useEffect(() => {

        // This code from js core is needed for ios devices
        const d = document.getElementById(name || '');
        document.addEventListener('MobileSearchButtonClickEvent', () => {
            if (d) {
                d.focus();
            }
        });
        document.addEventListener('HeaderSearchClick', () => {
            if (d) {
                d.focus();
            }
        });

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    });

    React.useEffect(() => {
        useDeviceDetect();
        if (navigator.platform === 'iPhone' || navigator.platform === 'iPad' || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 0)) setIsIpadIphone(true);
        getLandscapeMode();
        checkIfMobile();
    }, []);

    React.useEffect(() => {
        if (isIpadIphone && landscapeMode && showSearchFilters) {
            setTimeout(() => window.scrollTo(300, 300), 500);
        }
    }, [landscapeMode, isIpadIphone, showSearchFilters]);

    React.useEffect(() => {
        if (isGlobalClick) {
            if (textFieldRef && textFieldRef.current) {
                textFieldRef.current.focus();
            }
        }
    }, [isGlobalClick]);
    //  CONTEXT
    const onCloseContext = React.useContext(ModalContext);

    React.useEffect(() => {
        if (!showSearchFilters) {
            setSearchFilterState('Search all');
            setCurrPlaceholderIndex(0);
            setCurrLogoutPlaceholderIndex(0);
            setShowTabBtn(false);
            setShowClearBtn(false);
            if (onComplete) onComplete();
            onCloseContext();
        } else {
            if (searchText && searchText.length > 0) {
                setShowClearBtn(true);
                if (searchText.length > 2) {
                    setShowTabBtn(true);
                }
            } else {
                setShowClearBtn(true);
                setShowTabBtn(false);
                setIsTextArea(false);
            }
            setSearchValue(searchText || '');
        }
    }, [searchText, showSearchFilters]);

    const cleanup = () => {
        setIsLLMSearch(false);
        setSubmitGenAISearch(false);
        setGenAIResponse(null);
        setSearchFilterState('Search all');
        setShowTabBtn(false);
        setShowClearBtn(false);
        setLoading(false);
        setMaxCharErrMsg('');
        setSearchValue('');
        setResponse([]);
        setCurrPlaceholderIndex(0);
        setCurrLogoutPlaceholderIndex(0);
        if (onComplete) onComplete();
        onCloseContext();
    };

    const reset = () => {
        if (onChangeEvent) onChangeEvent('', true);
        cleanup();
    };

    React.useEffect(() => {
        const close = (e: any) => {
            if (e.keyCode === 27) {
                const element = document.getElementById('typeahead_close');
                if (element) element.click();
            }
        };
        window.addEventListener('keydown', close);
        return () => window.removeEventListener('keydown', close);
    }, []);

    const checkkContentWidth = () => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        if (context && textFieldRef.current) {
            context.font = getComputedStyle(textFieldRef.current).font;
            const contentWidth = context.measureText(searchValue).width;
            return contentWidth > (textFieldRef.current.offsetWidth - 40);
        }
        return false;
    };

    const activateTextAreaOrInput = (isContentWidthExceeded: boolean) => {
        const focusElement = () => {
            setTimeout(() => {
                const inp: any = textFieldRef.current;
                if (inp) {
                    const l: any = inp.value.length;
                    inp.focus();
                    inp.setSelectionRange(l, l);
                }
            }, 100);
        };
        // if (searchValue.length > maxChars) {
        if (isContentWidthExceeded && !isMobile) {
            setIsTextArea(true);
            focusElement();
        } else if (isTextArea) {
            setIsTextArea(false);
            focusElement();
        }
    };

    const handleOnFocus = (event: React.FocusEvent) => {
        setShowClearBtn(true);
        setCurrPlaceholderIndex(0);
        const isContentWidthExceeded = checkkContentWidth();
        // this is temporarily fix of scrolling bug at the safari browser
        // search input, on focus, should scrolls to the page center
        if (isIpadIphone && landscapeMode) {
            setTimeout(() => window.scrollTo(300, 300), 100);
        } else setTimeout(() => window.scrollTo(0, 0), 100);

        activateTextAreaOrInput(isContentWidthExceeded);
        if (onFocusEvent) onFocusEvent(event);

        // iPhone cursor appearance fix
        setTimeout(() => {
            const element = document.getElementById('hero-search-form');
            if (element) element.style.caretColor = 'black';
        }, 500);
    };


    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (isLLMSearch && genAIResponse && feedback !== '') {
            setClearFeedbackFlag(true);
            setFeedback('');
        }
        if (isModal) {
            const { target } = event;
            const { value } = target;
            const regex = /^\s+/g;
            const newSearch = value.replace(regex, '');
            if (newSearch.length > 500) {
                setMaxCharErrMsg(maxSearchTextError);
            } else if (maxCharErrMsg.length > 0) setMaxCharErrMsg('');
            setSearchValue(newSearch);
            if (onChangeEvent) onChangeEvent(newSearch, true);
            if (newSearch.length) {
                setLoading(true);
                if (newSearch.length > 2) {
                    setShowTabBtn(true);
                }
            }
            if (isIpadIphone && landscapeMode && newSearch.length === 0) {
                setTimeout(() => window.scrollTo(300, 300), 100);
            }
        }
    };

    const handleNoSearchResultsBtnState = (totallen: number, filteredlen: number) => {
        if (searchFilterState === 'Datasets' && totallen - filteredlen === 0) {
            if (showSolBtn) setShowSolBtn(false);
            if (showBPBtn) setShowBPBtn(false);
        } else if (searchFilterState === 'Datasets' && totallen - filteredlen > 0) {
            if (response.some(el => 'MktplaceSolutionName' in el) === true) {
                setShowSolBtn(true);
            }
            if (response.some(el => 'MarketplaceBlueprintName' in el) === true) {
                setShowBPBtn(true);
            }
        } else if (searchFilterState === 'Solutions' && totallen - filteredlen === 0) {
            if (showDSBtn) setShowDSBtn(false);
            if (showBPBtn) setShowBPBtn(false);
        } else if (searchFilterState === 'Solutions' && totallen - filteredlen > 0) {
            if (response.some(el => 'id' in el) === true) {
                setShowDSBtn(true);
            }
            if (response.some(el => 'MarketplaceBlueprintName' in el) === true) {
                setShowBPBtn(true);
            }
        } else if (searchFilterState === 'Blueprints' && totallen - filteredlen === 0) {
            if (showSolBtn) setShowSolBtn(false);
            if (showDSBtn) setShowDSBtn(false);
        } else if (searchFilterState === 'Blueprints' && totallen - filteredlen > 0) {
            if (response.some(el => 'id' in el) === true) {
                setShowDSBtn(true);
            }
            if (response.some(el => 'MktplaceSolutionName' in el) === true) {
                setShowSolBtn(true);
            }
        } else if (searchFilterState === 'Search all' && totallen > 0) {
            if (response.some(el => 'id' in el) === false) {
                setShowDSBtn(false);
            }
            if (response.some(el => 'MktplaceSolutionName' in el) === false) {
                setShowSolBtn(false);
            }
            if (response.some(el => 'MarketplaceBlueprintName' in el) === false) {
                setShowBPBtn(false);
            }
        } else if (totallen === 0) {
            setShowDSBtn(false);
            setShowSolBtn(false);
            setShowBPBtn(false);
        }

        if (searchValue.length > 2) {
            if (filteredlen === 0) setShowTabBtn(false);
            else setShowTabBtn(true);
        }
        if (isIpadIphone && landscapeMode) {
            setTimeout(() => window.scrollTo(300, 300), 100);
        }
    };

    useDebounce(
        () => {
            const type = getSearchType();
            if (searchValue.length && isModal && type === SearchType.openSearch) {
                setIsLLMSearch(false);
                APIManager.search(searchValue.trim(), undefined).then(res => {
                    const data = get(res, 'data.hits.hits', []).map((hit: Hit) => {

                        if (hit._source.isType === 'Solution') {
                            if (!['Solutions', 'Search all'].includes(searchFilterState)) {
                                return null;
                            }
                            const x = mapSearchResultToSolution(hit._source);
                            const arr = authdata([x as APISolution], userEmail);
                            if (arr && arr.length > 0) {
                                if (!showSolBtn) {
                                    setShowSolBtn(true);
                                }
                                return x;
                            }
                            return null;
                        }
                        if (hit._source.isType === 'Blueprint') {
                            if (!['Blueprints', 'Search all'].includes(searchFilterState)) {
                                return null;
                            }
                            const x = mapSearchResultToBluePrint(hit._source);
                            if (!showBPBtn) {
                                setShowBPBtn(true);
                            }
                            return x;
                        }
                        if (!['Datasets', 'Search all'].includes(searchFilterState)) {
                            return null;
                        }
                        if (!showDSBtn) {
                            setShowDSBtn(true);
                        }
                        return mapSearchResultToDataProfileCard(hit._source);
                    });
                    let updatedData = [];
                    updatedData = data.filter((x: (DataProfileCard | APISolution | APIBlueprint)) => !!x);
                    if (!enabledBlueprintFlag) {
                        updatedData = updatedData.filter((x: any) => x.KeyMarketplaceBlueprint === undefined);
                    }
                    Window.dataLayer.push({
                        event: 'searchSubmit',
                        searchTerm: searchValue,
                        searchResultsCount: updatedData.length
                    });

                    setResponse(updatedData);
                    setLoading(false);
                    handleNoSearchResultsBtnState(data.length, updatedData.length);
                }).catch(error => {
                    if (!(error && error.message && error.message === 'Search canceled due to new request.')) {
                        console.error(error);
                    }
                });
            } else if (type === SearchType.llmSearch) {
                setIsLLMSearch(true);

            }
        },
        throttleDuration,
        [searchValue, searchFilterState]
    );

    const handleFiltersClick = (event: React.MouseEvent, filterState: string) => {
        setSearchFilterState(filterState);
        const scrollableWrapper = document.getElementsByClassName('typeahead__searchfilbtn')[0];
        if (filterState === 'Search all') {
            scrollableWrapper.scrollLeft -= 100;
        }
        if (filterState === 'Blueprints') {
            scrollableWrapper.scrollLeft += 100;
        }
    };

    const onTabPressed = (value1: string) => {
        let d;
        if (value1 === 'hero-product-finder-icon-btn') {
            if (searchFilterState === 'Search all') {
                d = document.getElementById('typeahead-searchAllLink');
            }
            if (searchFilterState === 'Datasets') {
                d = document.getElementById('typeahead-datasetsLink');
            }
            if (searchFilterState === 'Solutions') {
                d = document.getElementById('typeahead-solutionsLink');
            }
            if (searchFilterState === 'Blueprints') {
                const searchIcon = searchValue ? 'hero-product-finder-redicon-btn' : 'hero-product-finder-icon-btn';
                d = document.getElementById(searchIcon);
            }
        }
        if (value1 === 'data-search-bar-btn') {
            if (searchValue) {
                d = document.getElementById('hero-product-finder-redicon-btn');
            } else {
                d = document.getElementById('hero-product-finder-icon-btn');
            }
        }
        if (value1 === 'typeahead-blueprintsLink') {
            d = document.getElementById(value1);
        }
        if (value1 === 'gen-ai-result-end') {
            d = document.getElementById('kenshoIcon');
        }

        if (value1 === 'hero-search-form') {
            d = document.querySelector('#typeahead_close svg');
        }
        if (d) d.focus();
    };

    const handleBlur = () => {
        onTabPressed('hero-search-form');
        setIsTextArea(false);

        // iPhone cursor appearance fix
        const element = document.getElementById('hero-search-form');
        if (element) element.style.caretColor = 'auto';
    };

    // we use this helper method to define filer button icon color, depend on state
    const filterBtnIconFill = (isActive: boolean) => {
        return isActive ? 'black' : '#515151';
    };

    const handleKeyEvent = (event: React.KeyboardEvent) => {
        if (event.keyCode === 8) {
            const element = document.getElementById('hero-search-form');
            if (element) element.focus();
        }
    };

    // Example success callback function
    const handleSuccess = () => {
        console.log('Email request succeeded');
    };

    // Example error callback function
    const handleEmailError = (errorMessage: any) => {
        console.error(`Email request failed: ${errorMessage}`);
    };

    const emailStatusCallback = (hasRequestSuccess: boolean, successCallback: () => void, error: (error: string) => void) => {
        if (hasRequestSuccess) {
            successCallback();
        } else {
            error('Email request  failed');
        }
    };

    const sendEmail = (errorBody: string, errorSubject: string, includeKensho: boolean) => {
        APIManager.sendEmail(
            errorBody,
            errorSubject,
            includeKensho ? spgVariables.KENSHOLLMEmailList : spgVariables.LLMEmailList,
            (isSuccess: boolean) => {
                emailStatusCallback(isSuccess, handleSuccess, handleEmailError);
            }
        );
    };

    const sendSearchFailedEmail = (value: string, reason: any, includeKensho: boolean) => {
        const errorData = '<br>SearchValue - '.concat(value);
        const errorText = '<br>Reason - '.concat(JSON.stringify(reason));
        const errorBody = 'Gen AI Search service error: '.concat(errorData).concat(errorText);
        const errorSubject = (env ? env.toUpperCase().concat(' - ') : '').concat('Marketplace Gen AI Search Service Error');
        sendEmail(errorBody, errorSubject, includeKensho);
    };

    const handleGenAIError = (isRequestManuallyCanceled = false) => {
        setLoading(false);
        setSubmitGenAISearch(false);
        if (onSearchTypeChanged) onSearchTypeChanged(true);
        if (!isRequestManuallyCanceled) {
            setHasGenAISearchError(true);
            setGenAIResponse([]);
        }
    };

    const getUserType = () => {
        const internalExternal = isValidUser ? 'internal' : 'external';
        const userType = isLoggedIn ? internalExternal : 'not_authenticated';
        return userType;
    };

    const getQueryData = () => {
        const data = {
            query: searchValue,
            user_type: getUserType()
        };
        return data;
    };

    const onGenAISearchClick = () => {
        if (searchValue) {
            setLoading(true);
            const data = getQueryData();
            Window.dataLayer.push({
                event: 'homepageSearchSubmitLLM',
                searchQuestion: data.query,
            });
            APIManager.getLLMAccessToken().then(token => {
                APIManager.getChatiqSearchById(data, token && token.data && token.data.AccessToken ? token.data.AccessToken : '').then(res => {
                    setLoading(false);
                    setSubmitGenAISearch(false);
                    if (onSearchTypeChanged) onSearchTypeChanged(true);
                    if (res.data) {
                        if (res.data.response_uuid && res.data.response) {
                            setGenAIResponse(res.data);
                            setHasGenAISearchError(false);
                        } else {
                            setHasGenAISearchError(true);
                            setGenAIResponse([]);
                            sendSearchFailedEmail(searchValue, res.data, true);
                        }
                    }
                }).catch(error => {
                    const isCanceled = axios.isCancel(error);
                    handleGenAIError(isCanceled);
                    if (!isCanceled) sendSearchFailedEmail(searchValue, error && error.message ? error.message : 'Search Service Error', true);
                });
            }).catch(er => {
                const isReqCanceled = axios.isCancel(er);
                handleGenAIError(isReqCanceled);
                if (!isReqCanceled) sendSearchFailedEmail(searchValue, 'LLM Access Token Service Error', false);
            });
        }
    };

    const sendFeedbackFailedEmail = (data: any, reason: any, includeKensho: boolean) => {
        console.log('Gen AI Feedback service error, data=', JSON.stringify(data));
        const errorData = '<br>Data - '.concat(JSON.stringify(data));
        const errorText = '<br>Reason - '.concat(JSON.stringify(reason));
        const errorBody = 'Gen AI Feedback service error:'.concat(errorData).concat(errorText);
        const errorSubject = (env ? env.toUpperCase().concat(' - ') : '').concat('Marketplace Gen AI Feedback Service Error');
        sendEmail(errorBody, errorSubject, includeKensho);
    };

    const handleFeedback = (id: string, flag: string) => {
        setFeedback(flag);
        const data = {
            response_uuid: id,
            feedback_flag: flag
        };
        APIManager.getLLMAccessToken().then(token => {
            APIManager.sendChatiqSearchFeedbackById(data, token && token.data && token.data.AccessToken ? token.data.AccessToken : '').then(res => {
                if (!(res.status === 200 && res.data === '')) {
                    sendFeedbackFailedEmail(data, res.data, true);
                }
            }).catch(error => {
                sendFeedbackFailedEmail(data, error && error.message ? error.message : 'Feedback Service Error', true);
            });
        }).catch(() => {
            sendFeedbackFailedEmail(data, 'LLM Access Token Service Error', false);
            console.log('Gen AI Feedback service access token error, data=', JSON.stringify(data));
        });
    };

    const handleOnSubmit = (event: React.FormEvent<HTMLFormElement> | KeyboardEvent) => {
        event.preventDefault();
        const type = getSearchType();
        if (type === SearchType.llmSearch) {
            if (searchValue.length > 500) {
                setLoading(false);
                setSubmitGenAISearch(false);
                return;
            }
            if (onFocusEvent) onFocusEvent(event);
            setSubmitGenAISearch(true);
            if (onSearchTypeChanged) onSearchTypeChanged(false);
            onGenAISearchClick();
        } else {
            reset();
            if (searchValue || searchValue.trim().length > 0) {
                if (searchFilterState && searchFilterState === 'Datasets') {
                    History.push(`/${langCode}/search-results?search=${encodeURIComponent(searchValue.trim())}&tab=1`);
                } else if (searchFilterState && searchFilterState === 'Solutions') {
                    History.push(`/${langCode}/search-results?search=${encodeURIComponent(searchValue.trim())}&tab=2`);
                } else if (searchFilterState && searchFilterState === 'Blueprints') {
                    History.push(`/${langCode}/search-results?search=${encodeURIComponent(searchValue.trim())}&tab=3`);
                } else {
                    History.push(`/${langCode}/search-results?search=${encodeURIComponent(searchValue.trim())}`);
                }
            } else History.push(`/${langCode}/search-results`);
        }
    };

    const keyPressHandler = (event: KeyboardEvent) => {
        let itemId = '';
        if (event.key === 'Enter') {
            if (event.target instanceof HTMLElement) {
                itemId = event.target.getAttribute('id') || '';
            }
            if (itemId && itemId === 'hero-search-form') {
                handleOnSubmit(event);
            }
        }
    };

    React.useEffect(() => {
        const container = textFieldRef ? textFieldRef.current : null;
        if (container) container.addEventListener('keydown', keyPressHandler);
        return () => {
            if (container) {
                container.removeEventListener('keydown', keyPressHandler);
            }
        };
    });

    const clearFeedbackDoneNotify = () => {
        setClearFeedbackFlag(false);
    };

    React.useEffect(() => {
        if (onDisableEnableSearchBtn) onDisableEnableSearchBtn(submitGenAISearch);
    }, [submitGenAISearch]);

    const currentPlaceHolderSetUp = (curPlaceholder: any, element: HTMLElement) => {
        setTimeout(() => {
            if (curPlaceholder === genAIPlaceholder) setCurrPlaceholderIndex((prev => (prev + 1) % genAIPlaceholder.length));
            if (curPlaceholder === genAILogoutPlaceholder) setCurrLogoutPlaceholderIndex((prev => (prev + 1) % genAILogoutPlaceholder.length));
            element.classList.remove('text-fade');
            element.classList.add('text-show');
        }, 1000);
    };

    React.useEffect(() => {
        const interval = setInterval(() => {
            const element = document.getElementById('hero-search-form');
            if (element && element !== document.activeElement && !showSearchFilters) {
                element.classList.remove('text-show');
                element.classList.add('text-fade');

                if (genAIPlaceholder && genAIPlaceholder.length > 0) {
                    currentPlaceHolderSetUp(genAIPlaceholder, element);
                }
            } else {
                setCurrPlaceholderIndex(0);
            }
        }, 4000);
        return () => clearInterval(interval);
    }, [genAIPlaceholder]);

    React.useEffect(() => {
        const interval = setInterval(() => {
            const element = document.getElementById('hero-search-form');
            if (element && element !== document.activeElement && !showSearchFilters) {
                element.classList.remove('text-show');
                element.classList.add('text-fade');

                if (genAILogoutPlaceholder && genAILogoutPlaceholder.length > 0) {
                    currentPlaceHolderSetUp(genAILogoutPlaceholder, element);
                }
            } else {
                setCurrLogoutPlaceholderIndex(0);
            }
        }, 4000);
        return () => clearInterval(interval);
    }, [genAILogoutPlaceholder]);

    const getPlaceholder = () => {
        if (showSearchFilters) return isLoggedIn ? genAIPlaceholder && genAIPlaceholder[0] : genAILogoutPlaceholder && genAILogoutPlaceholder[0];
        return isLoggedIn ? genAIPlaceholder && genAIPlaceholder[currPlaceholderIndex] : genAILogoutPlaceholder && genAILogoutPlaceholder[currLogoutPlaceholderIndex];
    };

    React.useEffect(() => {
        const element = document.getElementById('hero-search-form');
        const isMacLaptop = navigator.platform.toUpperCase().indexOf('MAC') >= 0 && navigator.maxTouchPoints === 0;
        if (element) {
            if (!showSearchFilters || (showSearchFilters && window.innerWidth <= 500)) {
                if (isIpadIphone || isMacLaptop) {
                    element.classList.add('ios');
                    element.classList.remove('non-ios');
                } else {
                    element.classList.add('non-ios');
                    element.classList.remove('ios');
                }
            } else {
                element.classList.remove('non-ios');
                element.classList.remove('ios');
            }
        }
    });

    React.useEffect(() => {
        if (textFieldRef.current) {
            const inp: any = textFieldRef.current;
            const estPlaceholderMaxChars = Math.floor(inp.offsetWidth) / 12;
            let longest = 0;
            if (genAIPlaceholder && genAIPlaceholder.length > 0) {
                longest = Math.max(...(genAIPlaceholder.map((el: string) => el.length)));
            }
            const isMobileDevice = window.matchMedia('(pointer: coarse)').matches;
            if (isMobileDevice && window.innerWidth >= 1024 && longest > estPlaceholderMaxChars && !showSearchFilters) {
                if (longest - estPlaceholderMaxChars < 5) {
                    textFieldRef.current.classList.remove('placeholderFont18');
                    textFieldRef.current.classList.remove('placeholderFont16');
                    textFieldRef.current.classList.add('placeholderFont22');
                } else if (longest - estPlaceholderMaxChars >= 5 && longest - estPlaceholderMaxChars < 15) {
                    textFieldRef.current.classList.remove('placeholderFont22');
                    textFieldRef.current.classList.remove('placeholderFont16');
                    textFieldRef.current.classList.add('placeholderFont18');
                } else {
                    textFieldRef.current.classList.remove('placeholderFont22');
                    textFieldRef.current.classList.remove('placeholderFont18');
                    textFieldRef.current.classList.add('placeholderFont16');
                }
            } else {
                textFieldRef.current.classList.remove('placeholderFont18');
                textFieldRef.current.classList.remove('placeholderFont16');
                textFieldRef.current.classList.remove('placeholderFont22');
            }
        }
    });

    React.useEffect(() => {
        if (searchValue === '122333') {
            setShowDeliveryPlatformSelector(!showDeliveryPlatformSelector);
        }
    }, [searchValue]);

    // max number of characters till input text overflow
    // 6.5 is estimated avarage char width for current font size
    const updateMaxChars = () => {
        if (textFieldRef.current) {
            const inp: any = textFieldRef.current;
            const estimatedMaxChars = Math.floor(inp.offsetWidth) / 6.5 - 10;
            setMaxChars(estimatedMaxChars);
        }
    };

    React.useEffect(() => {
        updateMaxChars();
    });

    React.useEffect(() => {
        APIManager.getGenAIPrompts().then(resp => {
            const promptList = Array.isArray(resp.data) ? resp.data : [];
            const genAIPlaceholderNew = promptList.filter((x: GenAIPrompt) => x.updoperation < 2 && x.promptDisplay !== 'O')
                .sort((a, b) => a.formOrder - b.formOrder)
                .map(n => n.genAIPromptText);
            setGenAIPlaceholder(genAIPlaceholderNew);
            const getGenAILogoutPlaceholderNew = promptList.filter((x: GenAIPrompt) => x.updoperation < 2 && x.promptDisplay !== 'I')
                .sort((a, b) => a.formOrder - b.formOrder)
                .map(n => n.genAIPromptText);
            setGenAILogoutPlaceholder(getGenAILogoutPlaceholderNew);
        });
    }, []);

    return (
        <div ref={textFieldAndDropdownRef} className="typeahead__wrapper">
            <form action="/search-results" data-testid="search-form" noValidate onSubmit={handleOnSubmit}>
                <Grid container className="typeahead__gridContainer" direction="row">
                    <Grid item className={cn('typeahead', className, showSearchFilters ? 'typeahead__mob_search_overlay' : '')}>
                        {iconPrepend}
                        { (window.innerWidth <= 1024 || window.matchMedia('(pointer: coarse)').matches || isTouchDevice || isMobile) ? showMobileToolTipIcon() : showToolTipIcon()}
                        <div className={`typeahead__input ${langCode === 'ja' ? 'jaLang' : ''}`}>
                            <Waypoint>
                                <UnstyledTextInput
                                    type="search"
                                    className={!showSearchFilters ? 'input_txt_animation' : ''}
                                    // autoFocus={false}
                                    autoComplete="off"
                                    fullWidth
                                    id={name}
                                    multiline={isTextArea && !isMobile}
                                    onBlur={handleBlur}
                                    name={name}
                                    onChange={handleOnChange}
                                    onFocus={handleOnFocus}
                                    onClick={() => {}}
                                    placeholder={getPlaceholder()}
                                    value={searchValue}
                                    inputRef={textFieldRef}
                                    inputProps={{
                                        style: {
                                            caretColor: `${isModal ? 'auto' : 'transparent'}`
                                        },
                                        'aria-label': getPlaceholder(),
                                        'data-testid': 'typeahead-input'
                                    }}
                                />
                            </Waypoint>
                        </div>
                        { showClearBtn && showSearchFilters && (
                            <>
                                {isLoggedIn && showDeliveryPlatformSelector && (
                                    <Filter
                                        isRadio={false}
                                        key="key"
                                        filterKey="deliveryPlatform"
                                        filterTitle="Delivery Platform"
                                        filterItems={deliveryPlatforms}
                                        onUpdate={(e: any) => setDeliveryPlatforms(e)}
                                        showSearch={false}
                                        isGenAiDeliveryPlatformSelect
                                    />
                                )}
                                <div className={cn('typeahead__tab', isTextArea ? 'typeahead__tab_textarea' : '')}>
                                    <button type="button" data-testid="clear-btn" ref={clearIconRef} id="typeahead_close" className="button button--icon-only typeahead__clearicon" aria-label="clear-icon" onClick={reset}>
                                        <ClearIcon />
                                    </button>
                                </div>
                            </>
                        )}
                    </Grid>
                    <Grid item className={cn(showSearchFilters ? 'typeahead__mob_search_overlay' : '')}>
                        {iconAppend}
                    </Grid>
                </Grid>
            </form>
            {showSearchFilters && !isMobile && maxCharErrMsg && maxCharErrMsg.length > 0 && (<span className="typeahead__error-message">{maxCharErrMsg}</span>)}
            {isLLMSearch && showSearchFilters && (
                <GenAIResponse
                    response={genAIResponse}
                    isLoading={loading && submitGenAISearch}
                    handleFeedback={handleFeedback}
                    hasError={hasGenAISearchError}
                    clearFeedbackFlag={clearFeedbackFlag}
                    clearFeedbackDoneNotify={clearFeedbackDoneNotify}
                    parentRef={textFieldAndDropdownRef}
                    onTabPressed={onTabPressed}
                    isLoggedIn={isLoggedIn}
                />
            )}
            { ((isLLMSearch && showSearchFilters && !submitGenAISearch && !genAIResponse) || (!isLLMSearch && showSearchFilters)) && (
                <>
                    <div className={`typeahead__searchfilbtn ${langCode === 'ja' ? 'jaLang' : ''}`}>
                        <div
                            role="tab"
                            id="typeahead-searchAllLink"
                            className={cn(searchFilterState === 'Search all' ? 'typeahead__searchfilbtn__active' : '', !response.length && !!searchValue && !showDSBtn && !showSolBtn ? 'typeahead__searchfilbtn--disabled' : '', 'typeahead__searchfilbtn__searchfiltonbutton')}
                            onClick={e => { handleFiltersClick(e, 'Search all'); }}
                            onFocus={() => { setSearchFilterState('Search all'); }}
                            onKeyUp={e => { handleKeyEvent(e); }}
                            tabIndex={0}
                            data-testid="typeahead-search-all"
                            aria-selected={searchFilterState === 'Search all'}
                        >
                            <div>
                                <SearchAllFilterIcon fill={filterBtnIconFill(searchFilterState === 'Search all')} />
                            </div>
                            <span>
                                {searchAllFilter}
                            </span>
                        </div>
                        <div
                            role="tab"
                            id="typeahead-datasetsLink"
                            className={cn(searchFilterState === 'Datasets' ? 'typeahead__searchfilbtn__active' : '', !response.some(el => ('id' in el)) && !!searchValue && !showDSBtn ? 'typeahead__searchfilbtn--disabled' : '', 'typeahead__searchfilbtn__searchfiltonbutton')}
                            onClick={e => { handleFiltersClick(e, 'Datasets'); }}
                            onFocus={() => { setSearchFilterState('Datasets'); }}
                            onKeyUp={e => { handleKeyEvent(e); }}
                            tabIndex={0}
                            data-testid="typeahead-search-dataset"
                            aria-selected={searchFilterState === 'Datasets'}
                        >
                            <div>
                                <DatasetsFilterIcon fill={filterBtnIconFill(searchFilterState === 'Datasets')} />
                            </div>
                            <div>
                                {datasetsFilter}
                            </div>
                        </div>
                        <div
                            role="tab"
                            id="typeahead-solutionsLink"
                            className={cn(searchFilterState === 'Solutions' ? 'typeahead__searchfilbtn__active' : '', !response.some(el => 'MktplaceSolutionName' in el) && !!searchValue && !showSolBtn ? 'typeahead__searchfilbtn--disabled' : '', 'typeahead__searchfilbtn__searchfiltonbutton')}
                            onClick={e => { handleFiltersClick(e, 'Solutions'); }}
                            onFocus={() => { setSearchFilterState('Solutions'); }}
                            onKeyUp={e => { handleKeyEvent(e); }}
                            tabIndex={0}
                            data-testid="typeahead-search-solution"
                            aria-selected={searchFilterState === 'Solutions'}
                        >
                            <div>
                                <SolutionsFilterIcon fill={filterBtnIconFill(searchFilterState === 'Solutions')} />
                            </div>
                            <div>
                                {solutionsFilter}
                            </div>
                        </div>
                        {enabledBlueprintFlag && (
                            <div
                                role="tab"
                                id="typeahead-blueprintsLink"
                                className={cn(searchFilterState === 'Blueprints' ? 'typeahead__searchfilbtn__active' : '', !response.some(el => ('MarketplaceBlueprintName' in el)) && !!searchValue && !showBPBtn ? 'typeahead__searchfilbtn--disabled' : '', 'typeahead__searchfilbtn__searchfiltonbutton')}
                                onClick={e => { handleFiltersClick(e, 'Blueprints'); }}
                                onFocus={() => { setSearchFilterState('Blueprints'); }}
                                onKeyUp={e => { handleKeyEvent(e); }}
                                tabIndex={0}
                                data-testid="typeahead-search-blueprint"
                                aria-selected={searchFilterState === 'Blueprints'}
                            >
                                <div>
                                    <BlueprintsFilterIcon fill={filterBtnIconFill(searchFilterState === 'Blueprints')} />
                                </div>
                                <div>
                                    {blueprintsFilter}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="typeahead__searchfilbtn--a" />
                </>

            )}
            {!isLLMSearch && showSearchFilters && isModal && loading && searchValue.length > 0 && (<div className="typeahead__spinnericon"><Spinner disable={!loading} /></div>)}
            {!isLLMSearch && !!searchValue && !loading && !response.length && isModal && showSearchFilters && (
                <SearchEmptyResults
                    noResultsFound={emptySearchSection.title}
                    message={emptySearchSection.content}
                    isLLMSearch
                    otherPages
                />
            )}

            {!isLLMSearch && !autoClose && showSearchFilters && (
                <TypeaheadDropdown
                    dataProfiles={response}
                    inputRef={textFieldRef}
                    isMobileDropdown={isMobileDropdown}
                    searchToken={searchValue}
                    loading={loading}
                    onClick={reset}
                    parentRef={textFieldAndDropdownRef}
                    searchFilter={searchFilterState}
                    onTabPressed={onTabPressed}
                />
            )}

            {!isLLMSearch && response.length > 5 && isMobileDropdown && showSearchFilters && (
                <div className="typeahead-dropdown__mobile-button__container">
                    <CustomLink
                        buttonTheme="tertiary"
                        className="typeahead-dropdown__mobile-button"
                        isButton
                        isFullWidth
                        text={`${seeAllResults} (${response.length})`}
                        url={`/search-results?search=${encodeURIComponent(searchValue.trim())}`}
                        onClick={reset}
                    />
                </div>
            )}
        </div>
    );
}

export default React.memo(Typeahead);
